import React from 'react';

const TextInput = ({ question, value, onChange, error }) => {
  return (
    <div className="question-input">
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={question.placeholder}
        className={`quiz-input ${error ? 'error' : ''}`}
        required={question.required}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default TextInput;